import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { Dict, NameValuePair } from 'src/app/types/decorable';
import { GeolocationPropertyOption } from 'src/app/model/api-services/qualifiers/geo-location-qualifier-service';

@Component({
	selector: 'app-casting-geoloc-part-sel',
	templateUrl: './casting-geoloc-part-sel.component.html',
	styleUrls: ['./casting-geoloc-part-sel.component.scss']
})
export class CastingGeolocPartSelComponent implements OnInit {

	public options: Array<NameValuePair> = [
		{ value: '', name: 'Select a Geolocation Part' },
		{ value: 'lattitude', name: 'Lattitude' },
		{ value: 'longitude', name: 'Longitude' },
		{ value: 'accuracy', name: 'Accuracy' },
		{ value: 'altitude', name: 'Altitude' },
		{ value: 'altitudeAccuracy', name: 'Altitude Accuracy' },
		{ value: 'heading', name: 'Heading' },
		{ value: 'speed', name: 'Speed' },
		{ value: 'timestamp', name: 'Timestamp' }
	];
	public defaultIndex = 0;
	public _val = '';

	@Input('value')
	set value(val: GeolocationPropertyOption) {

		if (this._val !== val) {
			this._val = val;
		} else {
			return;
		}
		this.valueChange.emit(val);
	}
	get value(): GeolocationPropertyOption {
		return this._val as GeolocationPropertyOption;
	}
	@Output()
	public valueChange = new EventEmitter<GeolocationPropertyOption>();
	constructor() { }

	ngOnInit(): void {
	}
}
